export const calculateLoan = async (requested_amount) => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/calculate-loan`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        requested_amount,
      }),
    }
  );

  const data = await response.json();
  return data.results;
};
